module.exports = __webpack_public_path__ + "img/新月祈願縮小.56ff9000.svg";